'use client';

import { HierarchicalMenu } from 'react-instantsearch';

import { FilterHeading } from '@/components/atomic/molecules';

const classNameGroup = {
  checkbox:
    'content-searchkit-checkbox searchkit-checkbox checked:content-searchkit-checkbox-checked',
  count: 'bg-brand text-white border-none font-medium text-xs',
  labelText:
    'text-sm text-dim-gray font-medium searchkit-label-text cursor-pointer',
  list: 'flex flex-col gap-4 max-h-80 overflow-auto',
  searchBox: 'searchkit-search-box',
  searchableForm: 'searchkit-search-box-form',
  selectedItem: 'searchkit-selected-item',
  showMore: 'searchkit-filter-show-more-button'
};

const DynamicFilter = ({
  filterProps: { componentProps, Component, headerProps }
}) => (
  <div>
    <FilterHeading {...{ headerProps }} />
    <Component {...componentProps} />
  </div>
);

const SearchSortFilterProductsWebOrganism = () => {
  const dynamicFilters = [
    {
      componentProps: {
        attributes: [
          'categoryLevels.level_0',
          'categoryLevels.level_1',
          'categoryLevels.level_2'
        ],
        classNames: {
          ...classNameGroup,
          childList: '!mt-2',
          label:
            'text-sm text-dim-gray font-medium searchkit-label-text cursor-pointer',
          list: 'flex flex-col gap-3',
          root: 'searchkit-search-box-event-type max-h-96'
        }
      },
      Component: HierarchicalMenu,
      headerProps: {
        heading: 'Category',
        includedAttributes: [
          'categoryLevels.level_0',
          'categoryLevels.level_1',
          'categoryLevels.level_2'
        ]
      }
    }
  ];

  return (
    <div className='w-80 hidden md:block'>
      <div className='searchkit-filter-container'>
        <div className='border-t border-platinum mb-4'></div>
        <FilterHeading
          {...{
            headerProps: {
              borderStyle: 'mt-3 mb-4',
              clearLabel: 'Clear All',
              heading: 'Filters',
              headingStyle: 'text-xl'
            }
          }}
        />
        <div className='border-t border-platinum mt-3 mb-4'></div>
        {dynamicFilters.map((filterProps, index) => (
          <div key={index}>
            <DynamicFilter {...{ filterProps }} />
            <div className='border-t border-platinum mt-3 mb-4' />
          </div>
        ))}
      </div>
    </div>
  );
};

export default SearchSortFilterProductsWebOrganism;
